<div class="footer-holder" >
    <div class="container-fluid">
     <div [innerHtml] = "FooterHtml"> 
     </div>
    </div>
  </div>
  